import { render, staticRenderFns } from "./modal-treatments.vue?vue&type=template&id=23f5fb79&"
import script from "./modal-treatments.vue?vue&type=script&lang=js&"
export * from "./modal-treatments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports